import { render, staticRenderFns } from "./ProductCardSwatches.vue?vue&type=template&id=4767395e&"
import script from "./ProductCardSwatches.vue?vue&type=script&lang=js&"
export * from "./ProductCardSwatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/parker/lets_code/frances-valentine/new-fv-original/FV-original/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4767395e')) {
      api.createRecord('4767395e', component.options)
    } else {
      api.reload('4767395e', component.options)
    }
    module.hot.accept("./ProductCardSwatches.vue?vue&type=template&id=4767395e&", function () {
      api.rerender('4767395e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/product-card/ProductCardSwatches.vue"
export default component.exports